<template>
  <div class="container-fluid mb-6 mb-md-0">
    <router-view :key="$route.name" />
  </div>
</template>

<script>
export default {
  name: 'Member',
  created() {
    this.$store.dispatch('syncParentCourses');
    this.$store.dispatch('syncPublicParentCourses');
  }
};
</script>

<style lang="scss">
</style>
